export default "__VITE_ASSET__69da43f7__"